import { ContentStore } from '../api/ContentStore';
import { DateTime, Duration } from 'luxon';
import { GroupDateMapper } from '../utils/GroupDateMapper';
import { useQuery } from '@tanstack/react-query';
import { marked } from 'marked';

export type ScienceSomethingContent = {
  content: { title: string; body: string; offset: number; duration: number };
};

export class GetScienceSomethingViewCreator {
  constructor(private readonly content: ContentStore = new ContentStore()) {}

  public async CreateView(groupStart: DateTime, groupId: number): Promise<ScienceSomethingContent> {
    const contentItems = await this.content.getScienceSomethingContent(groupId, (item) => {
      return {
        title: String(item.title),
        body: marked(item.body),
        offset: Number(item.offset),
        duration: Number(item.duration),
      };
    });
    const dateMapper = new GroupDateMapper(groupStart);
    const date = DateTime.local().toISODate();
    const currentOffset = dateMapper.day(date);

    const info = contentItems.find((item) => {
      return item.offset <= currentOffset && item.offset + item.duration >= currentOffset;
    });

    return { content: info } as ScienceSomethingContent;
  }
}

export const useGetScienceSomethingViewCreator = (groupStart: DateTime, groupId: number) =>
  useQuery({
    queryKey: ['GetScienceSomethingViewCreator'],
    queryFn: () => new GetScienceSomethingViewCreator().CreateView(groupStart, groupId),
    staleTime: Duration.fromObject({ minutes: 10 }).milliseconds,
  });
